export default {
  sm: `
  SPIRIT OF
  DATA CENTER
  GAK
  `,
  md: `
  SPIRIT OF DATA
  CENTER GAK
  `,
  xxl: `
  SPIRIT OF
  DATA CENTER GAK
  `
};
